import Shader from './Shader';

export default class FragmentShader extends Shader {

	constructor(gl, data) {
		super(gl, gl.FRAGMENT_SHADER, data);
	}

}
